import { joinPointsToLines } from './line/join-points-to-lines.js';
import { toPath } from './line/to-path.js';
import { distance as PointsDistance } from "./point/distance.js";
import { sortByNumericProperty } from "@ixfx/arrays";
/**
 * Create from set of points, connected in order starting at array position 0.
 * @param waypoints
 * @param opts
 * @returns
 */
export const fromPoints = (waypoints, opts = {}) => {
    const lines = joinPointsToLines(...waypoints);
    return init(lines.map((l) => toPath(l)), opts);
};
/**
 * Initialise
 *
 * Options:
 * * maxDistanceFromLine: Distances greater than this are not matched. Default 0.1
 * @param paths
 * @param opts
 * @returns
 */
export const init = (paths, opts = {}) => {
    //const enforceOrder = opts.enforceOrder ?? true;
    const maxDistanceFromLine = opts.maxDistanceFromLine ?? 0.1;
    const checkUnordered = (pt) => {
        const results = paths.map((p, index) => {
            const nearest = p.nearest(pt);
            const distance = PointsDistance(pt, nearest);
            // Relative position of nearest point on this path segment
            const positionRelative = p.relativePosition(nearest, maxDistanceFromLine);
            ;
            return { positionRelative, path: p, index, nearest, distance, rank: Number.MAX_SAFE_INTEGER };
        });
        const filtered = results.filter((v) => v.distance <= maxDistanceFromLine);
        const sorted = sortByNumericProperty(filtered, `distance`);
        // Assign ranks
        for (let rank = 0; rank < sorted.length; rank++) {
            sorted[rank].rank = rank;
        }
        return sorted;
    };
    // const checkUnordered = (p:Point) => {
    //   // Calculate progress of pointer between all the waypoint lines
    //   const progresses = lines.map((line, index) => (
    //     {
    //       index,
    //       score: Points.progressBetween(p, line.a, line.b)
    //     }));
    //   // Sort by closest
    //   const sorted = Arrays.sortByNumericProperty(progresses, `score`);
    // };
    return checkUnordered;
};
